// Global styles
import "@/assets/scss/main.scss";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import 'bootstrap-icons/font/bootstrap-icons.css'

// Importing Vue and other dependencies
import Vue from "vue";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import router from "./router";
import store from "./store";
import globalConfig from "./mixins/globalConfig";
import "vue2-datepicker/index.css"
import "@/assets/css/main.css";

import VueObserveVisibility from "vue-observe-visibility";

//Importing Bootstrap handpicked plugins (for smaller app size)
import BootstrapVue from "bootstrap-vue";
import { IconsPlugin } from "bootstrap-vue";
import browserDetect from "vue-browser-detect-plugin";

// Use Vue plugins
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueObserveVisibility);
Vue.use(browserDetect);
export const bus = new Vue();
import AppConstants from '@/constants/appConstants';
Vue.use(AppConstants);
Vue.config.productionTip = false;


// Fetch configuration and then initialize the app
store.dispatch("fetchConfig").then(() => {
  // Apply the globalConfig mixin globally
  Vue.mixin(globalConfig);

  // Initialize VueGtag with the config value
  const googleTagId = store.state.config.runtime?.GoogleTagId;
  if (googleTagId) {
    Vue.use(VueGtag, {
      config: { id: googleTagId },
    });
  }

  new Vue({
    render: (h) => h(App),
    store,
    router,
  }).$mount("#app");
});
